import { post } from './request';// 获取网站基本配置信息  get, formData, put 
export function get_configs(data) {
  return post('Index/get_configs', data);
}

// 获取站点背景图
export function get_bgimg(data) {
  return post('Index/get_bgimg', data);
}

// 获取轮播图列表
export function get_banner_list(data) {
  return post('Index/get_banner_list', data);
}

// 获取首页品牌故事列表
// Index/get_homelist
export function get_homelist(data) {
  return post('Index/get_homelist', data);
}

//获取大事件列表
export function get_brand_event_list(data) {
  return post('Index/get_brand_event_list', data);
}

//获取大事件列表详情
export function get_brand_event_info(data) {
  return post('Index/get_brand_event_info', data);
}

// 获取集团概况详情
export function get_group_info(data) {
  return post('Index/get_group_info', data);
}

// 获取成员企业列表
export function get_brand_list(data) {
  return post('Index/get_brand_list', data);
}

// 获取成员企业详情
export function get_brand_info(data) {
  return post('Index/get_brand_info', data);
}
// 获取企业动态列表
export function get_dynamics_list(data) {
  return post('Index/get_dynamics_list', data);
}
// 获取企业动态详情
export function get_dynamics_info(data) {
  return post('Index/get_dynamics_info', data);
}
// 获取集团公告列表
export function get_dynamic_notice_list(data) {
  return post('Index/get_dynamic_notice_list', data);
}
// 获取集团公告详情
export function get_dynamic_notice_info(data) {
  return post('Index/get_dynamic_notice_info', data);
}
// 获取集团期刊列表
export function get_dynamic_journal_list(data) {
  return post('Index/get_dynamic_journal_list', data);
}
// 获取集团期刊详情
export function get_dynamic_journal_info(data) {
  return post('Index/get_dynamic_journal_info', data);
}
// 获取产品分类列表
export function get_product_category_list(data) {
  return post('Index/get_product_category_list', data);
}
// 获取产品列表
export function get_product_list(data) {
  return post('Index/get_product_list', data);
}
// 获取产品详情
export function get_product_info(data) {
  return post('Index/get_product_info', data);
}
// 获取商务合作详情
export function get_cooperation_info(data) {
  return post('Index/get_cooperation_info', data);
}
// 获取举报热线详情
export function get_hotline(data) {
  return post('Index/get_hotline', data);
}
// 获取人才招聘
export function get_recruitment(data) {
  return post('Index/get_recruitment', data);
}
// 在线留言提交表单
export function sub_online(data) {
  return post('Index/sub_online', data);
}